import React from 'react'
import SectionHomeDesktop from './SectionHomeDesktop'
import SectionHomeReponsive from './SectionHomeResponsive'

export default function SectionHome() {
  return (
    <>
      {
        window.screen.width >= 1024 ? 
          <SectionHomeDesktop /> : 
          <SectionHomeReponsive />
      }
    </>
  )
}